import React from "react";
import PropTypes from "prop-types";


const MoreOptionItem = ({name, value}) => {
    return (
        <div className={'detail-item'}>
            <span className={'detail-item-name content-body body-md-regular'}>{name}</span>
            <div className={'detail-item-value content-body body-md-regular'}>{value}</div>
        </div>
    )
}

MoreOptionItem.propTypes = {
    /**
     * Name of the download option, e.g Diemsions, Bleed etc
     */
    name: PropTypes.string.isRequired,
    /**
     * Download option value
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

export default MoreOptionItem